import React from 'react';
import './App.css';
import MainComponent from './MainComponent';
import { ToastContainer } from 'react-toastify';
import CombinedProviders from './Contexts/CombinedProviders';

const App = () => {
  return (
    <>
      <CombinedProviders>
        <MainComponent />
      </CombinedProviders>
      <ToastContainer />
    </>
  );
};

export default App;
